import { core } from '@tock/coretypes';
import { tocktix } from '@tock/protos/dist/types/core';

/**
 * Copied from clowncar/src/js/utils/smsUtils.ts
 */

/**
 * Due to our number pool, this field was used to track unsubscribes from SMS before we had
 * the concept of SmsPhone. It is now legacy, but we still need to check it for older patrons
 * who may have unsubscribed before we had the new system in place.
 *
 * @deprecated
 */
export function isLegacyUnsubscribedFromSms(
  patron: core.Patron | tocktix.messages.IPatron
): boolean {
  return !!patron?.unsubscribedFromSms;
}

/**
 * Check if SmsPhone.StatusType is OPT_OUT_HARD, meaning a patron can only resubscribe by following specific instructions
 * which does NOT include using our UI.
 */
export function isSmsPhoneStatusTypeOptOutHard(
  status: core.SmsPhone.StatusType | null | undefined
): boolean {
  return status === 'OPT_OUT_HARD';
}

/**
 * Check if the SmsPhone.StatusType is OPT_IN, which means a patron has opted in to receiving SMS
 * in our new twilio world.
 */
export function isSmsPhoneStatusTypeOptIn(
  status: core.SmsPhone.StatusType | null | undefined
): boolean {
  return status === 'OPT_IN';
}

/**
 * Convert numeric SmsPhone.StatusType enum values to their string representations.
 * The backend API returns numeric enum values, but our utilities expect string values.
 *
 * These are copied to PhoneFieldset in shared as well.
 */
const STATUS_TYPE_MAP: Record<number, core.SmsPhone.StatusType> = {
  0: 'NOT_SPECIFIED',
  1: 'OPT_OUT_HARD',
  2: 'OPT_IN',
  3: 'OPT_OUT_SOFT',
};

export function normalizeSmsPhoneStatusType(
  status: core.SmsPhone.StatusType | number | null | undefined
): core.SmsPhone.StatusType {
  if (status === null || status === undefined) {
    return 'NOT_SPECIFIED';
  }
  // If it's already a string, return as-is
  if (typeof status === 'string') {
    return status;
  }
  // If it's a number, convert using the map
  return STATUS_TYPE_MAP[status] ?? 'NOT_SPECIFIED';
}
